import { z } from "zod";

export enum DisputeStatusEnum {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    REJECTED = 'Rejected'
}

export const DisputeStatusEnumSchema = z.nativeEnum(DisputeStatusEnum)

export const DisputeViewSchema = z.object({
    id: z.string(),
    admin_message: z.string().nullable(),
    dispute_date: z.coerce.date(),
    dispute_message: z.string().nullable(),
    dispute_reason: z.string(),
    status: z.nativeEnum(DisputeStatusEnum),
    buyer_lead_id: z.string(),
    admin_created: z.boolean(),
}, { description: 'DisputeViewSchema' })
export type DisputeView = z.infer<typeof DisputeViewSchema>;

// deprecated, use DisputeView
export type Dispute = {
    deleted: Date | null;
    admin_message: string
    dispute_date: Date
    dispute_message: string
    dispute_reason: string
    id: string
    status: DisputeStatusEnum,
    buyer_lead_id: string
    created: Date
    admin_created: boolean
};

// limit this what is needed for the front end
export const DisputeCompositeViewSchema = DisputeViewSchema.extend({
    lead: z.object({
        id: z.string(),
        name: z.string(),
        phone: z.string(),
        email: z.string(),
        county: z.string(),
        state: z.string(),
        zip_code: z.string(),
    }),
    buyer_lead: z.object({
        id: z.string(),
        price: z.number(),
        sent: z.boolean(),
        sent_date: z.coerce.date().nullable(),
    }),
    buyer: z.object({
        id: z.string(),
        name: z.string(),
    }),
    lastAdminChange: z.object({
        admin_name: z.string(),
    }).nullable(),
})
export type DisputeCompositeView = z.infer<typeof DisputeCompositeViewSchema>;

export const BuyerDisputesViewSchema = z.object({
    buyerLeadId: z.string(),
    leadId: z.string(),
    disputeId: z.string(),
    disputeReason: z.string().nullable(),
    disputeMessage: z.string().nullable(),
    adminMessage: z.string().nullable(),
    disputeDate: z.coerce.date(),
    leadName: z.string(),
    status: DisputeStatusEnumSchema,
    adminCreated: z.boolean(),
}, { description: 'BuyerDisputesViewSchema' })

export type BuyerDisputesView = z.infer<typeof BuyerDisputesViewSchema>;

export const BuyerDisputesAdminViewSchema = BuyerDisputesViewSchema.extend({
    lastAdminToChange: z.string().nullable(),
})

export type BuyerDisputesAdminView = z.infer<typeof BuyerDisputesAdminViewSchema>;

export const CreateDisputeSchema = z.object({
    buyer_lead_id: z.string(),
    dispute_reason: z.string(),
    dispute_message: z.string(),
}, { description: 'CreateDisputeSchema' })
export type CreateDispute = z.infer<typeof CreateDisputeSchema>;

export const ApproveDisputeSchema = z.object({
    id: z.string(),
    buyer_lead_id: z.string(),
}, { description: 'ApproveDisputeSchema' })
export type ApproveDispute = z.infer<typeof ApproveDisputeSchema>;

export const DenyDisputeSchema = z.object({
    id: z.string(),
    admin_message: z.string(),
}, { description: 'DenyDisputeSchema' })
export type DenyDispute = z.infer<typeof DenyDisputeSchema>;

export const DisputeRateSchema = z.object({
    dispute_rate: z.number(),
}, { description: 'DisputeRateSchema' })
export type DisputeRate = z.infer<typeof DisputeRateSchema>;

export const DisputeRatesRequestSchema = z.object({
    ids: z.array(z.string()),
}, { description: 'DisputeRatesRequestSchema' })
export type DisputeRatesRequest = z.infer<typeof DisputeRatesRequestSchema>;

// Map of buyer id -> dispute rate (integer percentage)
export const DisputeRatesMapSchema = z.record(z.string(), z.number());
export type DisputeRatesMap = z.infer<typeof DisputeRatesMapSchema>;

export const AverageDisputeRateSchema = z.object({
    average_dispute: z.number(),
    dispute_count: z.number(),
    lead_count: z.number()
}, { description: 'AverageDisputeRateSchema' })
export type AverageDisputeRate = z.infer<typeof AverageDisputeRateSchema>;
